import React from 'react';

import FollowButtonWithQueryClientWrapper from '@components/FollowButton/FollowButtonWithQueryClientWrapper';
import { FollowType } from '@utils/backend-api/follow';

import styles from './styles.module.scss';

interface EventFollowBannerProps {
  followStatus: boolean;
  eventEntityId: number;
}

const EventFollowBanner = ({ followStatus, eventEntityId }: EventFollowBannerProps) => {
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <h1>The Information Events</h1>
        </div>
        <div className={styles.subText}>
          Follow to be notified about exciting future events at The Information
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <FollowButtonWithQueryClientWrapper
          followStatus={followStatus}
          followeeId={eventEntityId}
          followType={FollowType.Entity}
          variant="primary"
        />
      </div>
    </div>
  );
};

export default EventFollowBanner;
